import {configureStore, ThunkAction, Action} from '@reduxjs/toolkit';
import configurationReducer from '../features/configuration/configurationSlice';

export const store = configureStore({
  reducer: {
    configuration: configurationReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
